import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  width: '100%',
  position: 'relative',
  textAlign: 'initial',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1
};

const TabTemplate = ({ 'aria-labelledby': ariaLabelledBy, children, id, selected, style }) => {
  const templateStyle = Object.assign({}, styles, style);
  if (!selected) {
    templateStyle.display = 'none';
  }

  return (
    <div
      aria-labelledby={ariaLabelledBy}
      hidden={!selected}
      id={id}
      role="tabpanel"
      style={templateStyle}
    >
      {children}
    </div>
  );
};

TabTemplate.propTypes = {
  'aria-labelledby': PropTypes.string,
  children: PropTypes.node,
  id: PropTypes.string,
  selected: PropTypes.bool,
  style: PropTypes.object
};

export default TabTemplate;
